import { withInstall } from '@vuemap/vue-amap-util'
import GeoJSON from './GeoJSON.vue'

export const ElAmapGeojson = withInstall(GeoJSON)
export default ElAmapGeojson
